import React from 'react'
import { Grid, TextField } from '@mui/material'
import NumberFormat from 'react-number-format'
import JobRadioGroup from 'components/Drawers/JobDrawer/JobRadioGroup'
import { salaryTypeOptions } from 'components/Drawers/JobDrawer/constants'

const CompensationSection = ({ values, setState, showError }) => {
  const hasSalaryRangeError =
    values.salaryMin && values.salaryMax && values.salaryMin > values.salaryMax

  const minSalaryError = hasSalaryRangeError
    ? 'Min salary must be less than Max salary'
    : showError && !values.salaryMin
      ? 'Required'
      : ''

  const maxSalaryError = hasSalaryRangeError
    ? 'Min salary must be less than Max salary'
    : showError && !values.salaryMax
      ? 'Required'
      : ''

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JobRadioGroup
          required
          label='Salary Type'
          name='salaryType'
          value={values.salaryType}
          options={salaryTypeOptions}
          setState={setState}
          showError={showError}
        />
      </Grid>
      {values.salaryType && (
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={6}>
            <NumberFormat
              label='Min Salary *'
              value={values.salaryMin || ''}
              onValueChange={({ value }) => {
                if (/^\d*$/.test(value)) {
                  setState('salaryMin', value ? parseInt(value, 10) : null)
                }
              }}
              thousandSeparator
              prefix='$'
              required
              customInput={TextField}
              fullWidth
              size='small'
              error={!!minSalaryError}
              helperText={minSalaryError}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormat
              label='Max Salary *'
              value={values.salaryMax || ''}
              onValueChange={({ value }) => {
                if (/^\d*$/.test(value)) {
                  setState('salaryMax', value ? parseInt(value, 10) : null)
                }
              }}
              thousandSeparator
              prefix='$'
              required
              customInput={TextField}
              fullWidth
              size='small'
              error={!!maxSalaryError}
              helperText={maxSalaryError}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default CompensationSection
